// API Response Message Codes
export enum MessCode {
  Unknown = 0,
  IsOK = 1,
  Not200 = 2,
  NotHost = 3,
  IsNotBeNull = 4,
  NoDaTaFound = 5,
  Success = 6,
  ApiDateOut = 7,
  ApiDateFalse = 8,
  HashCode = 9,
  Exception = 10,
  Duplicate = 12,
  AlreadyDeleted = 13,
  AlreadyUsed = 14,
  NotExist = 15,
  NewAndInactive = 16,
  MissingInput = 17,
  NULLInput = 18,
  NegativeInput = 19,
  InitializeNew = 20,
  InvalidData = 21,
  InvalidTable = 22,
  InvalidConnection = 23,
  IncompleteProcessing = 24,
  RecheckInformation = 25,
  RecheckInStock = 26,
  DeleteFalse = 27,
  InvalidPartnerID = 28,
  InvalidTaxInfos = 29,
  MissingTaxAccounts = 30,
  MissingTaxInfos = 31,
  InvalidDatetime = 32,
  MissingByAdmin = 33,
  ExceptionMenu = 34, 
  LoginDateTime = 35,
  AccountLocked = 36,
  MissingDateTime = 37,
  HashCodeFalse = 38,
  RecheckDuplicateVoucherTaxNo = 39,
  RecheckDuplicateVoucherNo = 40,
  RecheckOfferAcnt = 41,
  RecheckVoucherNo = 42,
  RecheckPayableAcntId = 43,
  RecheckOfferCrAcntId = 44,
  RecheckChiPhi = 45,
  RecheckChiPhiVanChuyen = 46,
  RecheckDisntRate = 47,
  RecheckTtlDisntAmt = 48,
  RecheckDisntCrAcntId = 49,
  RecheckTtlDisntAmtInExc = 50,
  RefreshTokenExpired = 51,
  AuthenticateNotMatchRefresh = 52,
  LicenseExpired = 53,
  RecheckDisntDbAcntId = 54,
  RecheckRecvableAcntId = 55,
  RecheckOfferDbAcntId = 56,
  RecheckVoucherTaxNo = 57,
  RecheckVoucherTypeTaxSign = 58,
  RecheckVoucherTaxSign = 59
}

// API Response Type
export enum TypeRp {
  Unknown = 'Unknown',
  ListObj = 'ListObj',
  ItemObj = 'ItemObj'
}

// API Page Status
export enum ApiPageStatus {
  Unknown = 'Unknown',
  DangDung = 'DangDung',
  TamNgung = 'TamNgung',
  TatCa = 'TatCa'
}

// Account Status
export enum AccountStatus {
  Inactive = 0,
  Active = 1,
  Suspended = 2,
  Locked = 3
}

// Permission Actions (for funcsTagActive bit string)
export enum PermissionAction {
  VIEW = 0,      // Xem/Đọc
  CREATE = 1,    // Thêm mới
  UPDATE = 2,    // Cập nhật/Sửa
  DELETE = 3,    // Xóa
  EXPORT = 4,    // Xuất dữ liệu
  IMPORT = 5,    // Nhập dữ liệu
  APPROVE = 6,   // Duyệt
  REJECT = 7,    // Từ chối
}

// API Tags
export enum ApiTags {
  Camera = 'Camera',
  HeThong = 'HeThong',
  Home = 'Home'
}
